import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable,map } from 'rxjs';
import { IFinantialReport } from '../interfaces/finantial-report/ifinantial-report';
import { IFinantialReceiptsReport } from '../interfaces/finantial-receipts-report/ifinantial-receipts-report';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FinantialReceiptsReportService {

  date = new Date().getFullYear()
  unit = localStorage.getItem('unitId')
 
  url: string = 'http://localhost:3000/finantial_receipts_report';

  /* url: string = 'https://api-fake-r9p5.onrender.com/exam'; */
  

  constructor(private http: HttpClient) { }

  getMonthToMonth(filter: string) {
    return this.http.get(`${environment.url}/report/financial${filter}`);
  }

  getYearToYear(filter: string) {
    return this.http.get(`${environment.url}/report-year-to-year-revenue${filter}`);
  }
  getReportTypesOfRevenue(filter?: string) {
    return this.http.get(`${environment.url}/report-types-of-revenue${filter}`);
  }
  
  getAnnualResultsFinancial(filter: string) {
    return this.http.get(`${environment.url}/annual-results-financial${filter}`);
  }

  getResultMonthlyFinantial(filter: string) {
    return this.http.get(`${environment.url}/monthly-financial-movement${filter}`);
  }

  getRevenueYear(filter: string, csv?: boolean) {

    if(csv) {
      filter = filter + '&csv=true'
    }

    return this.http.get(`${environment.url}/annual-results-financial${filter}`);
  }



  get() {
    return this.http
      .get(this.url)
      .pipe(map((res: any) => res)) as Observable<IFinantialReceiptsReport>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IEmployeeReport>;
  }
}
